class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.cancelAutoClose = this.cancelAutoClose.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.notification.addEventListener('pointerdown', this.cancelAutoClose);
    this.notification.addEventListener('keydown', (evt) => evt.code !== 'Escape' && this.cancelAutoClose());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.startAutoClose();

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.cancelAutoClose();
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  startAutoClose() {
    this.cancelAutoClose();
    this.autoCloseTimer = window.setTimeout(() => this.close(), 8000);
  }

  cancelAutoClose() {
    if (!this.autoCloseTimer) return;
    window.clearTimeout(this.autoCloseTimer);
    this.autoCloseTimer = null;
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// The custom collection cards predate Dawn's product-form component. Route
// their submissions through the same section-rendering contract so the cart
// count and notification always reflect the new cart state.
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target.closest('.bk-card__form[data-product-form]');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const card = form.closest('.bk-card');
    const originalLabel = button.getAttribute('aria-label') || 'In den Warenkorb';
    const formData = new FormData(form);
    const quantity = Number(formData.get('quantity')) || 1;

    button.disabled = true;
    button.setAttribute('aria-label', 'Wird hinzugefügt');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || 'Cart add failed');

        if (card) {
          const product = {
            id: card.dataset.productId,
            title: card.dataset.productTitle,
            price: Number(card.dataset.productPrice) || 0,
            position: Number(card.dataset.productListPosition) || 0,
          };
          const item = {
            item_id: product.id,
            item_name: product.title,
            item_list_name: 'Bücher Kollektion',
            item_list_id: 'buecher_collection',
            index: product.position,
            price: product.price,
            currency: 'EUR',
            quantity,
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: { currency: 'EUR', value: product.price * quantity, items: [item] },
          });

          if (typeof window.fbq === 'function') {
            window.fbq('track', 'AddToCart', {
              content_ids: [product.id],
              content_name: product.title,
              content_type: 'product',
              value: product.price * quantity,
              currency: 'EUR',
              contents: [{ id: product.id, quantity }],
            });
          }
        }

        button.classList.add('is-success');
        button.setAttribute('aria-label', 'Im Warenkorb');

        if (cart && typeof cart.renderContents === 'function' && response.sections) {
          cart.renderContents(response);
        } else {
          window.location.assign(window.routes.cart_url);
          return;
        }

        window.setTimeout(() => {
          button.classList.remove('is-success');
          button.setAttribute('aria-label', originalLabel);
          button.disabled = false;
        }, 1800);
      })
      .catch((error) => {
        console.error('Cart-add error:', error);
        button.setAttribute('aria-label', 'Fehler beim Hinzufügen. Erneut versuchen');
        window.setTimeout(() => {
          button.setAttribute('aria-label', originalLabel);
          button.disabled = false;
        }, 2000);
      });
  },
  true
);
